export const monetizeRenderer = (_instance, td, _row, _col, _prop, value) => {
  if (value == null || !value) {
    td.innerHTML = `<div class="truncated"></div>`;
    return td;
  }

  const calculatedValue = value / 100;
  td.innerHTML = `<div class="truncated">$${new Intl.NumberFormat("en-US").format(calculatedValue)}</div>`;

  return td;
};
